import { BaseLayout } from "./components/shared/layouts";
import { LightTheme } from "./theme";
import React from "react";

export const wrapWithProvider = ({ element }) => {
  return <BaseLayout theme={LightTheme}>{element}</BaseLayout>;
};
